import React from "react";
import "../../styles/module/blog.css";

import bg2 from "../../assets/images/img/bg-2.webp";
import arrow from "../../assets/images/img/downarrow.webp";
import bg3 from "../../assets/images/img/bg-3.svg";

export default function PrivacyPolicy() {
  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className=" landing__image-background-2 image-background"
        />
        <div className="rotated-text" onClick={() => window.location.href = '#scroll'}>
          <img
            src={arrow}
            alt="downarrow"
            className=""
          />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>{' '}scroll down</font>
            </font>
          </h4>
        </div>
        <div className="section">
          <img
            className="landing__image-background-1 image-background"
            src={bg3}
            alt="container background"
          />
          <div className="container blog-post single-page">
            <div id="scroll" className="content">
              <h5>PRIVACY POLICY</h5>
              <h2>
                We collect personal data to provide and improve our services,
                use it responsibly to enhance your experience, and take measures
                to protect your information securely.
              </h2>
              <h6>1. Introduction</h6>
              <ol>
                <li>
                  Genvix Tech is dedicated to safeguarding your privacy and
                  ensuring transparent handling of your personal information.
                  This Privacy Policy applies to all Genvix Tech digital
                  services, including mobile applications, websites, and any
                  other software or online platforms we operate. It explains how
                  we collect, use, share, and protect your data when you
                  interact with our services.
                </li>
              </ol>
              <h6>2. Information We Collect</h6>
              <ol>
                We collect various types of information to provide, improve, and
                personalize our services:
                <li>
                  <b>Personal Information:</b> Data that identifies you directly
                  or indirectly, such as your name, email address, phone number,
                  billing information, and account credentials.
                </li>
                <li>
                  <b>Device Information:</b> Technical details about the device
                  you use to access our services, including operating system,
                  device model, IP address, unique device identifiers, and
                  browser type.
                </li>
                <li>
                  <b>Usage Information:</b> Data about your interactions with
                  our services, including features used, pages visited, session
                  duration, click behavior, and other activity logs.
                </li>
                <li>
                  <b>Location Data:</b> When permitted, we may collect location
                  information from your device to provide location-based
                  services. Cookies and Tracking Technologies: We use cookies,
                  web beacons, and similar technologies to collect data on how
                  you use our websites and apps, to personalize content, and to
                  support analytics and advertising.
                </li>
                <li>
                  <b>Cookies and Tracking Technologies:</b> We use cookies, web
                  beacons, and similar technologies to collect data on how you
                  use our websites and apps, to personalize content, and to
                  support analytics and advertising.
                </li>
              </ol>
              <h6>3. How We Use Your Information</h6>
              <ol>
                Your information enables us to:
                <li>
                  Provide, operate, maintain, and improve our services across
                  all platforms.
                </li>
                <li>
                  Personalize your experience and deliver content relevant to
                  your preferences.
                </li>
                <li>
                  Communicate with you regarding account activity, updates,
                  promotions, and support.
                </li>
                <li>
                  Conduct analytics and research to better understand usage
                  patterns and enhance service quality.
                </li>
                <li>
                  Ensure security, prevent fraud, and comply with legal
                  obligations.
                </li>
                <li>Enforce our terms of service and other policies.</li>
              </ol>
              <h6>4. How We Share Your Information</h6>
              <ol>
                We may disclose your data under the following circumstances:
                <li>
                  <b>Service Providers:</b> Trusted third-party vendors who
                  perform services on our behalf (e.g., hosting, analytics,
                  payment processing, customer support). They are contractually
                  obligated to keep your information confidential and secure.
                </li>
                <li>
                  <b>Legal Compliance:</b> When required by law, legal process,
                  or governmental request.
                </li>
                <li>
                  <b>Business Transfer:</b> In connection with corporate
                  transactions such as mergers, acquisitions, or asset sales.
                </li>
                <li>
                  <b>Protection of Rights:</b> To protect our rights, property,
                  or safety, or those of our users or others.
                </li>
              </ol>
              <h6>5. Your Choices and Rights</h6>
              <ol>
                You have control over your personal information:
                <li>
                  <b>Marketing Preferences:</b> You can opt out of promotional
                  communications by following the unsubscribe instructions or
                  contacting us directly.
                </li>
                <li>
                  <b>Access and Correction:</b> You may request access to your
                  personal data and ask for corrections if necessary.
                </li>
                <li>
                  <b>Data Deletion:</b> You can request that we delete your
                  personal information, subject to certain legal or operational
                  exceptions.
                </li>
                <li>
                  <b>Cookie Management:</b> You can manage or disable cookies
                  via your browser settings or device preferences, although this
                  may affect service functionality.
                </li>
                <li>
                  <b> Do Not Track:</b> Our services currently do not respond to
                  “Do Not Track” signals.
                </li>
              </ol>
              <h6>6. Security</h6>
              <ol>
                <li>
                  We implement appropriate technical and organizational measures
                  to protect your data from unauthorized access, disclosure,
                  alteration, or destruction. Despite our efforts, no method of
                  electronic transmission or storage is entirely secure, and we
                  cannot guarantee absolute security.
                </li>
              </ol>
              <h6>7. Data Retention</h6>
              <ol>
                <li>
                  We retain personal information only for as long as necessary
                  to fulfill the purposes described in this policy or as
                  required by law. When data is no longer needed, we securely
                  delete or anonymize it.
                </li>
              </ol>
              <h6>8. Children’s Privacy</h6>
              <ol>
                <li>
                  Our services are not intended for children under the age of 13
                  (or applicable minimum age in your jurisdiction). We do not
                  knowingly collect personal data from children without parental
                  consent. If you believe we have collected such data, please
                  contact us for deletion.
                </li>
              </ol>
              <h6>9. International Transfers</h6>
              <ol>
                <li>
                  Your information may be transferred to and processed in
                  countries other than your own, including the United States and
                  other jurisdictions that may have different data protection
                  laws. We take steps to ensure appropriate safeguards for your
                  data in such transfers.
                </li>
              </ol>
              <h6>10. Changes to This Privacy Policy</h6>
              <ol>
                <li>
                  We may update this policy periodically to reflect changes in
                  our practices, technology, or legal requirements. We encourage
                  you to review this page regularly. Continued use of our
                  services constitutes acceptance of any updates.
                </li>
              </ol>
              <h6>11. Contact Us</h6>
              <ol>
                <li>
                  If you have questions, concerns, or requests regarding this
                  Privacy Policy or your personal data, please feel free to
                  contact us.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div id="about" className="section section__about__blog">
        <div className="container">
        </div>
      </div>
    </>
  );
}
